// extracted by mini-css-extract-plugin
export default {"gradientText":"GradientText_gradientText__A7DeV","animated":"GradientText_animated__v3Wck","gradientShift":"GradientText_gradientShift__Ea1nt"};